import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {HttpClient} from '@angular/common/http';
import {Client, Discount, Member} from 'app/models';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
// import {PrepareParams} from 'app/common/prepare-params';

@Injectable()
export class ClientsService {
  apiUrl: string;
  token: string;

  constructor(private http: HttpClient,
              private settings: SettingsService) {
    this.apiUrl = this.settings.apiUrl;
  }

  getClient(id): Observable<Client> {
    return this.http.get(`${this.apiUrl}/client/${id}`).pipe(map((resp: any) => {
      return new Client().setFromApiModel(resp);
    }));
  }


  deleteClient(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/client/${id}`).pipe(map((resp: any) => {
      return resp;
    }));
  }

  deleteMember(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/member/${id}`).pipe(map((resp: any) => {
      return resp;
    }));
  }

  updateClient(data): Observable<Client> {
    const id = data.id;
   // delete data.id;
    return this.http.put(`${this.apiUrl}/client/${id}`, data).pipe(map((resp: any) => {
      return new Client().setFromApiModel(resp);
    }));
  }

  createClient(data): Observable<Client> {
   // delete data.id;
    return this.http.post(`${this.apiUrl}/client`, data).pipe(map((resp: any) => {
      return new Client().setFromApiModel(resp);
    }));
  }

  updateMember(data): Observable<Member> {
    const id = data.id;
    delete data.id;
    delete data.clientId;
    return this.http.put(`${this.apiUrl}/member/${id}`, data).pipe(map((resp: any) => {
      return new Member().setFromApiModel(resp);
    }));
  }

  createMember(data): Observable<Member> {
    const clientId = data.clientId;
    delete data.id;
    delete data.clientId;
    return this.http.post(`${this.apiUrl}/client/${clientId}/member`, data).pipe(map((resp: any) => {
      return new Member().setFromApiModel(resp);
    }));
  }

  createDiscount(data: any, clientId: number): Observable<Discount> {
    return this.http.post(`${this.apiUrl}/client/${clientId}/discount`, data).pipe(map((resp: any) => {
      return new Discount().setFromApiModel(resp);
    }));
  }

  updateDiscount(data: any, clientId: number, id: number): Observable<Discount> {
    return this.http.put(`${this.apiUrl}/client/${clientId}/discount/${id}`, data).pipe(map((resp: any) => {
      return new Discount().setFromApiModel(resp);
    }));
  }

  // deleteDiscount(clientId: number, id: number): Observable<any> {
  //   return this.http.delete(`${this.apiUrl}/client/${clientId}/discount/${id}`);
  // }

  addSharedManager(clientId: number, sharedManagerId: number): Observable<any> {

    const data = {
      shared_manager_id: sharedManagerId,
    }
    return this.http.post(`${this.apiUrl}/client/${clientId}/share`, data).pipe(map((resp: any) => {
      return resp;
    }));
  }


  removeSharedManager(clientId: number): Observable<any> {

    return this.http.delete(`${this.apiUrl}/client/${clientId}/share`).pipe(map((resp: any) => {
      return resp;
    }));
  }
}
